import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTabs from "../../components/CustomTabs";
import Search from "../../components/Search";
import UserAvatar from "../../components/UserAvatar";
import {
    fuelGeneralDetails, fuelLogsLists, getFuelLogDetails,
    getVehicleDetailsByFuelLog, getVehiclePaginated, setActiveTab, setSelectedTripId
} from "../../store/Slices/FuelSlice";
import { images, imagesAlt } from "../../utils/images";
import SpinnerLoader from "../../utils/SpinnerLoader";
import {
    activeFuelLogIcon, activeFuelVehicleIcon, addTripIcon,
    fuelLogIcon, fuelVehicleIcon
} from "../../utils/svgs";
import VehicleStatus from "../../components/VehicleStatus";

const FuelLists = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [debouncedSearchText, setDebouncedSearchText] = useState("");

    const {
        loading,
        selectedTripId,
        viewAllTrips,
        activeTab,
        fuelLogsListsData,
        fuelLogsListsLoading,
        getVehiclePaginatedData,
        getVehiclePaginatedLoading
    } = useSelector((state) => state.fuel);

    useEffect(() => {
        const timer = setTimeout(() => {
            setPage(1);
            setDebouncedSearchText(searchText);
        }, 1000);

        return () => clearTimeout(timer);
    }, [searchText]);

    useEffect(() => {
        if (activeTab === "fuel") {
            dispatch(fuelLogsLists({ page: page, limit: 10, search_text: debouncedSearchText }));
        } else if (activeTab === "vehicles") {
            dispatch(getVehiclePaginated({ page: page, limit: 10, search_text: debouncedSearchText }));
        }
        else return;
    }, [dispatch, page, debouncedSearchText, activeTab]);

    const handleTabChange = (tab) => {
        dispatch(setActiveTab(tab));
        setPage(1);
    };

    useEffect(() => {
        if (activeTab === "fuel" && fuelLogsListsData?.length > 0) {
            const firstItem = fuelLogsListsData[0];
            dispatch(setSelectedTripId(firstItem.id));
            dispatch(getFuelLogDetails(firstItem.id));
            dispatch(fuelGeneralDetails(firstItem.id));
        } else if (activeTab === "vehicles" && getVehiclePaginatedData?.length > 0) {
            const firstItem = getVehiclePaginatedData[0];

            dispatch(setSelectedTripId(firstItem.id));
            dispatch(getVehicleDetailsByFuelLog(firstItem.id));
        }
    }, [activeTab, fuelLogsListsData, getVehiclePaginatedData, dispatch]);

    const tripsTabs = [
        {
            key: "fuel",
            label: "Fuel Logs",
            icon: activeTab === "fuel" ? activeFuelLogIcon : fuelLogIcon,
        },
        {
            key: "vehicles",
            label: "Vehicles",
            icon: activeTab === "vehicles" ? activeFuelVehicleIcon : fuelVehicleIcon,
        },
    ];

    let showData = null;
    if (activeTab === "fuel") {
        showData = fuelLogsListsData?.map((trip, index) => {
            const isActive = !viewAllTrips && selectedTripId === trip.id;
            const tripStatus = String(trip?.status || "").toLowerCase().trim();
            const isDeletable = tripStatus === "new" || tripStatus === "in_transit" || tripStatus === "in-transit";

            return (
                <div
                    className={`trip_list_main_div ${isActive ? "active" : ""}`}
                    key={trip?.id || index}
                    onClick={() => {
                        if (!viewAllTrips && selectedTripId === trip.id) return;
                        dispatch(setSelectedTripId(trip.id));
                        dispatch(getFuelLogDetails(trip.id));
                        dispatch(fuelGeneralDetails(trip.id));
                    }}
                >
                    <div className="trip_list_header">
                        <h5><span>{trip?.trip_id}</span></h5>
                        <div>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/fuel/${trip.id}`);
                                }}
                            >
                                View Details
                            </button>
                        </div>
                    </div>
                    <div className="trip_list_body" style={{ border: "none" }}>
                        <div className="trip_loc_view">
                            <p> Fuel Fill-ups</p>

                            <div className="fuel_fill_up">
                                <h6>
                                    {fuelLogIcon} {trip?.refilled_fuel_count ? trip?.refilled_fuel_count?.count : 0}
                                    <sub>Times</sub>
                                </h6>

                                <div className="d-flex">
                                    <img src={images.vehcileImg} alt={imagesAlt.vehcileImg} />
                                    <UserAvatar username={trip.primary_driver?.username} image={trip.primary_driver?.image} />
                                </div>
                            </div>
                        </div>

                        <div className="trip_speed_loc">
                            <p>Current Fuel in Tank (L)</p>
                            <div className="current_fuel">
                                <h6>
                                    {fuelLogIcon} -
                                    <sub>%</sub>
                                </h6>
                                <span>|</span>
                                <h6>- <sub>ltrs</sub></h6>
                            </div>
                        </div>
                    </div>
                </div>
            );
        })
    }
    else if (activeTab === "vehicles") {
        showData = getVehiclePaginatedData?.map((trip, index) => {
            const isActive = !viewAllTrips && selectedTripId === trip.id;

            return (
                <div
                    className={`trip_list_main_div ${isActive ? "active" : ""}`}
                    key={index}
                    onClick={() => {
                        if (!viewAllTrips && selectedTripId === trip.id) return;
                        dispatch(setSelectedTripId(trip.id));
                        dispatch(getVehicleDetailsByFuelLog(trip.id));
                    }}
                >
                    <div className="trip_list_header">
                        <h5>
                            <span>{trip?.registration_number}</span>
                        </h5>
                        <div>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/fuel/vehicle/${trip.id}`)
                                }}
                            >
                                View Details
                            </button>
                        </div>
                    </div>
                    <div className="trip_list_body" style={{ border: "none" }}>
                        <div className="trip_loc_view">
                            <p>Current Vehicle Status</p>
                            <VehicleStatus status={trip?.last_log?.status} className={trip?.last_log?.status} />
                        </div>

                        <div className="trip_speed_loc">
                            <p>4-Wheeler Nissan Truck</p>

                            <div className="d-flex">
                                <img src={images.vehcileImg} alt={imagesAlt.vehcileImg} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        })
    }

    return (
        <div>
            <CustomTabs
                tabs={tripsTabs}
                activeTab={activeTab}
                setActiveTab={handleTabChange}
            />

            <Search value={searchText} onChange={(e) => setSearchText(e.target.value)} />

            {
                (fuelLogsListsLoading || getVehiclePaginatedLoading) ? <SpinnerLoader /> :
                    showData?.length === 0 ? (
                        <div className="add_trip_suggestion_div">
                            {addTripIcon}
                            <h4>There is nothing here...</h4>
                            <p>
                                There is nothing to view right now, please add fuel log to get
                                started.
                            </p>
                        </div>
                    ) : showData
            }
        </div>
    );
};

export default FuelLists;
